var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "USA_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#USA_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0H0v1h21V0zm0 2H0v1h21V2zM0 4h21v1H0V4zm21 2H0v1h21V6zM0 8h21v1H0V8zm21 2H0v1h21v-1zM0 12h21v1H0v-1zm21 2H0v1h21v-1z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46467F",
    d: "M0 0h9v7H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#USA_svg__filter0_d_1145_135276)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.5a.5.5 0 11-1 0 .5.5 0 011 0zm2 0a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zM8 1.5a.5.5 0 11-1 0 .5.5 0 011 0zM2.5 3a.5.5 0 100-1 .5.5 0 000 1zM5 2.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zm1.5.5a.5.5 0 11-1 0 .5.5 0 011 0zM5.5 4a.5.5 0 100-1 .5.5 0 000 1zM4 3.5a.5.5 0 11-1 0 .5.5 0 011 0zM1.5 4a.5.5 0 100-1 .5.5 0 000 1zm1.5.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zM7 4.5a.5.5 0 11-1 0 .5.5 0 011 0zM7.5 6a.5.5 0 100-1 .5.5 0 000 1zM6 5.5a.5.5 0 11-1 0 .5.5 0 011 0zM3.5 6a.5.5 0 100-1 .5.5 0 000 1zM2 5.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: "url(#USA_svg__paint0_linear_1145_135276)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "USA_svg__paint0_linear_1145_135276",
    x1: 1,
    y1: 1,
    x2: 1,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "USA_svg__filter0_d_1145_135276",
    x: 1,
    y: 1,
    width: 7,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1145_135276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1145_135276",
    result: "shape"
  })))));
}
export default SvgUsa;